function normalizeFlags(review = {}) {
  const flags = Array.isArray(review?.flags) ? review.flags : [];

  return flags.map((flag, index) => {
    if (typeof flag === "string") {
      return {
        id: `flag-${index}`,
        message: flag,
        type: "general",
      };
    }

    return {
      id: flag?.rowId || `flag-${index}`,
      message: flag?.message || "Needs review",
      type: flag?.type || "general",
    };
  });
}

function getTone(type) {
  switch (type) {
    case "material":
      return "border-[#f3d6a0] bg-[#fff4ce] text-[#8a6d1d]";
    case "labour":
      return "border-[#f3d6a0] bg-[#fff4ce] text-[#8a6d1d]";
    case "price":
    case "pricing":
      return "border-[#f1aeb5] bg-[#fde7e9] text-[#a4262c]";
    case "optional":
      return "border-[#edebe9] bg-[#f3f2f1] text-[#605e5c]";
    default:
      return "border-[#edebe9] bg-white text-[#323130]";
  }
}

function getLabel(type) {
  switch (type) {
    case "material":
      return "Material";
    case "labour":
      return "Labour";
    case "price":
    case "pricing":
      return "Price pending";
    case "optional":
      return "Inactive row";
    default:
      return "Review";
  }
}

export default function ReviewPanel({ review = {} }) {
  const flags = normalizeFlags(review);
  const count = review?.count ?? flags.length;

  return (
    <section className="border-b border-[#edebe9] bg-white">
      <div className="flex items-center justify-between border-b border-[#edebe9] bg-[#faf9f8] px-4 py-3">
        <div>
          <h3 className="text-sm font-semibold text-[#201f1e]">
            Review required
          </h3>
          <p className="mt-0.5 text-xs text-[#605e5c]">
            Pricing or manual confirmation.
          </p>
        </div>

        <span className="rounded-sm border border-[#edebe9] bg-white px-2 py-0.5 text-xs font-medium text-[#605e5c]">
          {count}
        </span>
      </div>

      <div className="p-4">
        {!flags.length ? (
          <div className="rounded-sm border border-[#c7e0c0] bg-[#dff6dd] px-3 py-2 text-sm text-[#107c10]">
            No review flags.
          </div>
        ) : (
          <div className="space-y-2">
            {flags.map((flag) => (
              <div
                key={flag.id}
                className={`rounded-sm border px-3 py-2 ${getTone(flag.type)}`}
              >
                <div className="mb-1 text-[11px] font-semibold uppercase tracking-wide opacity-80">
                  {getLabel(flag.type)}
                </div>

                <div className="text-sm leading-snug">{flag.message}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}